// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1d0vG","subheader":"ReorderModal_subheader__Gl4dN","listWrap":"ReorderModal_listWrap__3muO1"};